<template lang="pug">
  .single-graph(ref="SingleGraph")
</template>
<script>
export default {
  name: 'SingleGraph',
  props: {
    opts: {
      type: Object,
      required: true
    },
    series: {
      required: false
    }
  },
  watch: {
    series: {
      deep: true,
      handler (val) {
        if (val) {
          this.updateSerise(val)
        }
      }
    }
  },
  data () {
    return {
      graph: null
    }
  },
  mounted () {
    this.initGraph()
  },
  methods: {
    initGraph () {
      this.graph = this.$echarts.init(this.$refs.SingleGraph)
      this.graph.showLoading()
    },
    updateSerise (serise) {
      const that = this
      const option = {
        backgroundColor: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: 'rgba(255, 255, 255, 0)'
            },
            {
              offset: 1,
              color: 'rgba(255, 255, 255, 0)'
            }
          ]
        },
        color: ['#535d90', '#1d3589', '#5888dd'],
        title: {
          text: that.opts.title,
          left: '1%',
          top: '2%',
          textStyle: {
            color: '#000',
            fontWeight: '400'
          }
        },
        grid: {
          left: '1%',
          right: '1%',
          top: '16%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          padding: 10,
          showTitle: false,
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0], '20%']
          },
          backgroundColor: 'rgba(245, 245, 245, 0.8)',
          axisPointer: {
            type: 'line'
          },
          textStyle: {
            color: '#000'
          }
        },
        xAxis: {
          type: 'category',
          maxInterval: 1,
          z: 5,
          boundaryGap: false,
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
          splitLine: {
            show: true,
            lineStyle: {
              color: '#eee'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#888'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: '#333'
            },
            show: false
          }
        },
        yAxis: [
          {
            type: 'value',
            z: 5,
            axisLine: {
              lineStyle: {
                color: '#888' // 左侧边框
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#eee' // 横坐标轴
              }
            },
            axisTick: {
              show: true
            },
            axisLabel: {
              textStyle: {
                color: '#333' // y轴文字颜色
              }
            }
          }
        ],
        series: {
          name: that.opts.legend1,
          smooth: true,
          type: 'line',
          markPoint: {
            data: []
          },
          showSymbol: false,
          lineStyle: {
            normal: {
              color: '#3f4b83',
              opacity: 0
            }
          },
          areaStyle: {
            normal: {
              color: '#3f4b83',
              opacity: 0.9
            }
          },
          data: [63, 69, 65, 85, 20, 59, 98, 62, 54, 58, 74, 85]
        }
      }
      var $data = serise
      // 如果只有一位，添加一个key和value都为0
      if (Object.keys($data).length === 1) {
        $data[0] = 0
      }
      var xA = []
      var xV = []
      for (var key in $data) {
        xA.push(key)
        xV.push($data[key])
      }
      option.xAxis.data = xA
      option.series.data = xV
      that.graph.hideLoading()
      that.graph.setOption(option)
      window.addEventListener('resize', function () {
        that.graph.resize()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.single-graph {
  width: 100%;
  height: 100%;
}
</style>
